export const MULTI_QUOTE_DATA = "MULTI_QUOTE_DATA";
export const MULTI_QUOTE_ERROR_DATA = "MULTI_QUOTE_ERROR_DATA";
export const MULTI_QUOTE_HIDE_ERROR_DATA = "MULTI_QUOTE_HIDE_ERROR_DATA";
export const MULTI_QUOTE_START_LOADER = "MULTI_QUOTE_START_LOADER ";
export const MULTI_QUOTE_STOP_LOADER = "MULTI_QUOTE_STOP_LOADER";
